import React from 'react';
import { Link } from 'react-router-dom';
import { useSubscription } from '../../../../../services/subscription/Subscription.provider';
import classes from './PrivateLogo.module.scss';

const PrivateLogoComponent = () => {
  const { configuration } = useSubscription();

  return (
    <Link to="/" className={classes.logo}>
      <img src={configuration?.logoUrl ?? ''} className={classes.logo__image} alt="logo" />
    </Link>
  );
};

export default PrivateLogoComponent;
